import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AccessoryCharge, PaymentCart } from '@cargos/sprintpay-models';
import { Subject, map, takeUntil } from 'rxjs';
import { CartBillService, ConfigService } from 'src/app/shared/services';
import { AccessoriesUtilsService } from '../../shared/services/accessories.service';

@Component({
    selector: 'app-extra-item',
    imports: [MatIconModule, CommonModule],
    templateUrl: './extra-item.component.html',
    styleUrls: ['./extra-item.component.scss'],
    standalone: true,
})
export class ExtraItemComponent implements OnInit, OnDestroy {
    private unsubscribe$: Subject<void>;
    public isDuplicated: boolean;
    public quantity: number;
    public calculateQuantityByExtraItems = false;

    @Input() paymentCart: PaymentCart;

    constructor(
        private cartBillService: CartBillService,
        private configService: ConfigService,
        private accessoriesService: AccessoriesUtilsService
    ) {
        this.unsubscribe$ = new Subject<void>();
    }

    ngOnInit(): void {
        this.getConfig();
        this.subscribeItemsDuplicates();

        if (this.calculateQuantityByExtraItems) {
            this.getItemRate();
        }
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    getConfig(): void {
        this.calculateQuantityByExtraItems = this.configService.calculateQuantityByExtraItems();
    }

    subscribeItemsDuplicates(): void {
        this.cartBillService
            .isThereDuplicatesByPayment(this.paymentCart)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((isDuplicated) => {
                this.isDuplicated = isDuplicated;
            });
    }

    getItemRate(): void {
        if (!this.paymentCart.externalData?.paymentType) {
            return;
        }

        this.accessoriesService
            .getAccessoryRateByPaymentType(this.paymentCart.externalData?.paymentType)
            .pipe(
                map((rate) => {
                    if (rate) {
                        this.quantity = AccessoryCharge.calculateTotalItems(this.paymentCart?.amount || 0, rate);
                    }
                }),
                takeUntil(this.unsubscribe$)
            )
            .subscribe();
    }
}
